export default __webpack_public_path__ + "empty-issues-md.3e7bf411.svg";